import React from "react";
import { Button } from "reactstrap";
import crashIllustration from "assets/img/rocket-error-crash.webp";

/**
 * Branded error fallback: crash-landing rocket illustration plus retry
 * button. Purely presentational — error catching/reporting stays in the
 * error boundary that renders this.
 */
function RocketErrorFallback({ supportingText, onRetry }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "32px 24px",
        textAlign: "center",
      }}
    >
      <img
        src={crashIllustration}
        alt=""
        aria-hidden="true"
        style={{
          width: "min(360px, 80vw)",
          height: "auto",
          marginBottom: "8px",
          borderRadius: "16px",
        }}
      />
      <h2
        style={{
          margin: "0 0 10px",
          color: "#1f2a44",
          fontWeight: 700,
          fontSize: "1.65rem",
        }}
      >
        Well... that didn&rsquo;t go as planned.
      </h2>
      <p style={{ maxWidth: "420px", color: "#64748b", margin: "0 0 24px", lineHeight: 1.5 }}>
        {supportingText}
      </p>
      <Button className="design-system-primary-solid" onClick={onRetry}>
        <i className="fa fa-refresh design-system-button-icon" aria-hidden="true" />
        Refresh Page
      </Button>
    </div>
  );
}

export default RocketErrorFallback;
